import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken:'',
    productCurrent:1
  },
  getters: {
  },
  mutations: {
    setAccessToken(state,accessToken){
      state.accessToken = accessToken
    },
    setProductCurrent(state,productCurrent){
      state.productCurrent = productCurrent
      console.log('出发')
    }
  },
  actions: {
  },
  modules: {
  }
})
